import {APICore} from "./apiCore";

const api = new APICore();

export async function doReportAction(data: any) {
    const baseUrl = `/reports/action`;
    return api.create(baseUrl, data);
}
